import { render, staticRenderFns } from "./home.vue?vue&type=template&id=4d0bced0&scoped=true"
var script = {}
import style0 from "./home.vue?vue&type=style&index=0&id=4d0bced0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0bced0",
  null
  
)

export default component.exports